<section class="transaction-detail-page">
  <div *ngIf="isLoading && !detail" class="detail-feedback">
    <p-progressSpinner strokeWidth="6" ariaLabel="Carregando"
      styleClass="transaction-detail-spinner"></p-progressSpinner>
    <span>Carregando...</span>
  </div>
  <div *ngIf="errorMessage" class="detail-feedback detail-feedback--error">{{ errorMessage }}</div>

  <ng-container *ngIf="!isLoading">
    <ng-container *ngIf="detail as d">
      <app-admin-page-header [title]="'Transação #' + d.id"
        subtitle="Detalhe administrativo, dados bancários e ações operacionais.">
        <div header-actions class="detail-header-actions">
          <button type="button" (click)="goBack()" class="admin-btn admin-btn--secondary">
            Voltar para a lista
          </button>
        </div>
      </app-admin-page-header>

      <p *ngIf="actionMessage" class="detail-feedback detail-feedback--success">{{ actionMessage }}</p>
      <p *ngIf="actionError" class="detail-feedback detail-feedback--error">{{ actionError }}</p>

      <div class="detail-sections">
        <section class="detail-section admin-surface">
          <div class="detail-section__header">
            <h3>Transação e dados bancários</h3>
          </div>

          <div class="detail-profile-grid">
            <article class="detail-card detail-card--nested">
              <h4>Dados da transação</h4>
              <div class="detail-kv">
                <span>ID</span>
                <strong>{{ d.id ?? '-' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Tipo</span>
                <strong>{{ resolveTransactionTypeLabel(d) }}</strong>
              </div>
              <div class="detail-kv" *ngIf="d.rejection_reason">
                <span>Motivo da reprovação</span>
                <strong>{{ d.rejection_reason }}</strong>
              </div>
              <div class="detail-kv" *ngIf="d.reviewed_by || d.reviewed_at">
                <span>Revisão</span>
                <strong>
                  <ng-container *ngIf="d.reviewed_by && d.reviewed_at">
                    {{ d.reviewed_by }} — {{ d.reviewed_at | date : 'dd/MM/yyyy HH:mm' }}
                  </ng-container>
                  <ng-container *ngIf="d.reviewed_by && !d.reviewed_at">{{ d.reviewed_by }}</ng-container>
                  <ng-container *ngIf="!d.reviewed_by && d.reviewed_at">{{
                    d.reviewed_at | date : 'dd/MM/yyyy HH:mm'
                    }}</ng-container>
                </strong>
              </div>
              <div class="detail-kv" *ngIf="d.paid_by || d.paid_at">
                <span>Pagamento registado</span>
                <strong>
                  <ng-container *ngIf="d.paid_by && d.paid_at">
                    {{ d.paid_by }} — {{ d.paid_at | date : 'dd/MM/yyyy HH:mm' }}
                  </ng-container>
                  <ng-container *ngIf="d.paid_by && !d.paid_at">{{ d.paid_by }}</ng-container>
                  <ng-container *ngIf="!d.paid_by && d.paid_at">{{
                    d.paid_at | date : 'dd/MM/yyyy HH:mm'
                    }}</ng-container>
                </strong>
              </div>
              <div class="detail-kv">
                <span>Valor / quantidade</span>
                <strong>
                  <ng-container *ngIf="d.amount != null || d.quantity != null">{{
                    d.amount ?? d.quantity
                    }}</ng-container>
                  <ng-container *ngIf="d.unit"> ({{ d.unit }})</ng-container>
                </strong>
              </div>
              <div class="detail-kv">
                <span>Moeda</span>
                <strong>{{ d.currency || '—' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Criada em</span>
                <strong>{{ d.created_at ? (d.created_at | date : 'dd/MM/yyyy HH:mm:ss') : '—' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Atualizada em</span>
                <strong>{{ d.updated_at ? (d.updated_at | date : 'dd/MM/yyyy HH:mm:ss') : '—' }}</strong>
              </div>
            </article>

            <article class="detail-card detail-card--nested">
              <h4>Dados bancarios (PIX)</h4>
              <ng-container *ngIf="d.banking as b; else noBanking">
                <div class="detail-kv">
                  <span>Nome completo</span>
                  <strong>{{ b.holder_name || '—' }}</strong>
                </div>
                <div class="detail-kv">
                  <span>Banco</span>
                  <strong>{{
                    b.bank_code != null && b.bank_name
                    ? b.bank_name + ' (' + b.bank_code + ')'
                    : b.bank_name || '—'
                    }}</strong>
                </div>
                <div class="detail-kv">
                  <span>Chave</span>
                  <strong>{{ b.pix_key || '—'
                    }}<ng-container *ngIf="b.pix_key_type"> ({{ b.pix_key_type }})</ng-container></strong>
                </div>
                <div class="detail-kv" *ngIf="b.bank_branch">
                  <span>Agência</span>
                  <strong>{{ b.bank_branch }}</strong>
                </div>
                <div class="detail-kv" *ngIf="b.account">
                  <span>Conta</span>
                  <strong>{{ b.account }}</strong>
                </div>
                <div class="detail-kv" *ngIf="b.iban">
                  <span>IBAN</span>
                  <strong>{{ b.iban }}</strong>
                </div>
              </ng-container>
              <ng-template #noBanking>
                <p class="detail-empty">Nenhum dado bancario cadastrado.</p>
              </ng-template>
            </article>
          </div>
        </section>

        <section class="detail-section admin-surface">
          <div class="detail-section__header">
            <h3>Dados do utilizador</h3>
          </div>

          <div class="detail-profile-grid">
            <article class="detail-card detail-card--nested">
              <h4>Conta</h4>
              <div class="detail-kv">
                <span>ID conta</span>
                <strong>{{ accountIdForUserLink ?? '—' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Username</span>
                <strong>{{ d.account?.username || '—' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Email</span>
                <strong>{{ d.account?.email || '—' }}</strong>
              </div>
              <div class="detail-kv">
                <span>Data de nascimento</span>
                <strong>{{
                  d.birthdate
                  ? (d.birthdate | date : 'dd/MM/yyyy')
                  : '—'
                  }}</strong>
              </div>
              <div class="detail-kv">
                <span>CPF</span>
                <strong>{{ d.document_number?.trim() || '—' }}</strong>
              </div>
              <div class="detail-kv" *ngIf="accountIdForUserLink != null">
                <span>Trusted</span>
                <ng-container *ngIf="canEditTrusted; else trustedReadonly">
                  <div class="transaction-detail-trusted-edit">
                    <div class="transaction-detail-trusted-edit__row">
                      <select id="trusted-draft" class="admin-input transaction-detail-trusted-edit__select"
                        [(ngModel)]="trustedDraft">
                        <option [ngValue]="true">Sim</option>
                        <option [ngValue]="false">Não</option>
                      </select>
                      <button type="button" class="admin-btn admin-btn--primary transaction-detail-trusted-edit__btn"
                        [disabled]="isTrustedSavePending || !trustedDirty" (click)="saveTrusted()">
                        Salvar
                      </button>
                    </div>
                    <div *ngIf="trustedDirty && trustedDraft === false && detail?.is_trusted === true"
                      class="transaction-detail-trusted-edit__reason">
                      <label for="trusted-revoke-reason">Motivo da revogação</label>
                      <textarea id="trusted-revoke-reason" class="admin-input" rows="2"
                        [(ngModel)]="trustedRevokeReason" placeholder="Obrigatório ao remover trusted"></textarea>
                    </div>
                  </div>
                </ng-container>
                <ng-template #trustedReadonly>
                  <strong>
                    <span *ngIf="d.is_trusted === true" class="transaction-detail-trusted-badge">Sim</span>
                    <span *ngIf="d.is_trusted === false">Não</span>
                    <span *ngIf="d.is_trusted !== true && d.is_trusted !== false">—</span>
                  </strong>
                </ng-template>
              </div>
              <div class="detail-kv" *ngIf="
                d.user_gem_balance != null ||
                d.user_coin_balance != null ||
                d.account?.gem_amount != null ||
                d.account?.coin_amount != null
              ">
                <span>Saldos (utilizador)</span>
                <strong>
                  Gemas:
                  {{
                  d.user_gem_balance ?? d.account?.gem_amount ?? '—'
                  }}
                  · Moedas:
                  {{ d.user_coin_balance ?? d.account?.coin_amount ?? '—' }}
                </strong>
              </div>
              <div class="detail-card__actions">
                <button type="button" class="admin-btn admin-btn--primary" (click)="goUserTransactions()"
                  [disabled]="accountIdForUserLink == null">
                  Ver transações do utilizador
                </button>
              </div>
            </article>

            <article class="detail-card detail-card--nested">
              <h4 class="detail-risk-heading">
                <span>Risco da conta</span>
                <span *ngIf="detailHasRisk(d)" class="transaction-detail-risk-x"
                  title="Conta com risco ou alerta aberto">✕</span>
                <span *ngIf="!detailHasRisk(d)" class="transaction-detail-risk-ok" title="Conta sem risco">✓</span>
              </h4>
              <p class="detail-risk-intro">
                Alertas ligados ao perfil do utilizador (conta), não à transação em si.
              </p>
              <ul class="alert-timeline" *ngIf="d.risk_alerts?.length">
                <li *ngFor="let alert of d.risk_alerts" class="alert-timeline__item">
                  <span class="alert-severity alert-severity--high">Conta</span>
                  <div class="alert-timeline__content">
                    <p class="transaction-detail-risk-text">{{ alert }}</p>
                  </div>
                </li>
              </ul>
              <ul class="alert-timeline" *ngIf="!d.risk_alerts?.length && detailHasRisk(d)">
                <li class="alert-timeline__item">
                  <span class="alert-severity alert-severity--high">Conta</span>
                  <div class="alert-timeline__content">
                    <p>Risco na conta identificado (sem texto detalhado).</p>
                  </div>
                </li>
              </ul>
              <p class="detail-empty" *ngIf="!d.risk_alerts?.length && !detailHasRisk(d)">
                Nenhum alerta aberto na conta.
              </p>
            </article>
          </div>

          <div class="detail-profile-grid detail-profile-grid--history">
            <article class="detail-card detail-card--nested detail-card--full">
              <div class="detail-card__header">
                <h4>Observações do utilizador (staff)</h4>
                <button (click)="openNoteModal()" class="admin-btn admin-btn--primary"
                  style="padding: 0.4rem 0.8rem; font-size: 0.8rem;" [disabled]="accountIdForUserLink == null">
                  + Nova Observação
                </button>
              </div>

              <p class="transaction-detail-staff-intro">
                Histórico interno associado à conta; as entradas permanecem listadas em todas as transações deste
                usuário.
              </p>

              <ng-container *ngIf="sortedNotes.length > 0; else noNotes">
                <ul class="alert-timeline">
                  <li *ngFor="let note of sortedNotes" class="alert-timeline__item">
                    <span class="alert-severity alert-severity--info">STAFF</span>
                    <div class="alert-timeline__content note-content-wrapper">
                      <div class="note-text-area">
                        <p>{{ note.description }}</p>
                        <span>{{ note.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div class="note-actions-inline">
                        <button class="note-icon-btn" (click)="openEditNoteModal(note)" title="Editar">
                          <i class="pi pi-pencil" aria-hidden="true"></i>
                        </button>
                        <button class="note-icon-btn note-icon-btn--danger" (click)="deleteNote(note.id)"
                          title="Deletar">
                          <i class="pi pi-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </ng-container>
              <ng-template #noNotes>
                <p class="detail-empty">Nenhuma observação interna registrada para esta conta.</p>
              </ng-template>
            </article>
          </div>
        </section>

        <section class="detail-section admin-surface" *ngIf="canRunCashOutPaymentActions && isCashOutTransaction(d)">
          <div class="detail-section__header">
            <h3>Ações operacionais</h3>
          </div>

          <article class="detail-card detail-card--nested">
            <p class="detail-empty" *ngIf="isActionPending">A processar…</p>

            <div class="transaction-detail-op-row" *ngIf="canEditWorkflowStage">
              <label class="transaction-detail-op-label" for="workflow-stage">Alterar etapa do saque</label>
              <div class="transaction-detail-op-controls">
                <select id="workflow-stage" class="admin-input transaction-detail-op-select"
                  [(ngModel)]="workflowStageDraft" [disabled]="isActionPending">
                  <option *ngFor="let opt of workflowStageOptions" [value]="opt.value">
                    {{ opt.label }}
                  </option>
                </select>
                <button type="button" class="admin-btn admin-btn--secondary" (click)="applyWorkflowStage()"
                  [disabled]="isActionPending || !workflowStageDraft">
                  Aplicar
                </button>
              </div>
            </div>

            <p *ngIf="!canEditWorkflowStage" class="detail-empty transaction-detail-finance-note">
              A alteração manual da etapa do saque é exclusiva de STAFF. Como parceiro financeiro, pode
              aprovar e pagar via Pix automático, reprovar ou registar pagamento com comprovante.
            </p>

            <div class="detail-card__actions">
              <button type="button" class="admin-btn admin-btn--primary" (click)="confirmApprove()"
                [disabled]="isActionPending">
                Aprovar e pagar PIX
              </button>
              <button type="button" class="admin-btn admin-btn--danger" (click)="openRejectDialog()"
                [disabled]="isActionPending">
                Reprovar pagamento
              </button>
              <button type="button" class="admin-btn admin-btn--success" (click)="openReceiptDialog()"
                [disabled]="isActionPending">
                Marcar pago com comprovante
              </button>
            </div>
          </article>
        </section>
      </div>
    </ng-container>
  </ng-container>
</section>

<p-dialog header="Aprovar e pagar PIX" [(visible)]="approvePaymentDialogVisible" [modal]="true"
  [style]="{ width: '30rem' }" [draggable]="false" [appendTo]="'body'"
  styleClass="transaction-detail-pay-dialog">
  <div class="transaction-detail-pay-confirm" *ngIf="detail as d">
    <div class="transaction-detail-pay-confirm__icon">
      <i class="pi pi-bolt" aria-hidden="true"></i>
    </div>
    <div>
      <h3>Confirmar aprovação e pagamento?</h3>
      <p>
        Esta ação vai aprovar o saque e chamar o Banco Inter para enviar
        <strong>{{ formatCurrency(d.value) }}</strong> via PIX.
      </p>
    </div>

    <dl class="transaction-detail-pay-confirm__details">
      <div>
        <dt>Nome completo</dt>
        <dd>{{ d.banking?.holder_name || d.full_name || '-' }}</dd>
      </div>
      <div>
        <dt>PIX</dt>
        <dd>{{ d.banking?.pix_key || '-' }} <span>{{ d.banking?.pix_key_type || '' }}</span></dd>
      </div>
      <div>
        <dt>ID transação</dt>
        <dd>{{ d.transaction_id || d.id || '-' }}</dd>
      </div>
    </dl>

    <p class="transaction-detail-pay-confirm__warning">
      Confirme apenas se os dados bancários foram conferidos. Após sucesso no Inter, o saque será marcado como pago.
    </p>

    <div class="transaction-detail-dialog__actions">
      <button type="button" class="admin-btn admin-btn--secondary" (click)="approvePaymentDialogVisible = false">
        Cancelar
      </button>
      <button type="button" class="admin-btn admin-btn--success" (click)="submitApprovePayment()"
        [disabled]="isActionPending">
        {{ isActionPending ? 'Pagando...' : 'Confirmar pagamento' }}
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Reprovar pagamento" [(visible)]="rejectDialogVisible" [modal]="true" [style]="{ width: '26rem' }"
  [draggable]="false" [appendTo]="'body'">
  <div class="transaction-detail-dialog">
    <label for="reject-reason">Motivo (obrigatório)</label>
    <textarea id="reject-reason" class="admin-input transaction-detail-dialog__textarea" rows="4"
      [(ngModel)]="rejectReason" placeholder="Descreva o motivo da reprovação"></textarea>
    <div class="transaction-detail-dialog__actions">
      <button type="button" class="admin-btn admin-btn--secondary" (click)="rejectDialogVisible = false">
        Cancelar
      </button>
      <button type="button" class="admin-btn admin-btn--danger" (click)="submitReject()"
        [disabled]="!rejectReason.trim()">
        Confirmar reprovação
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Marcar pago com comprovante" [(visible)]="receiptDialogVisible" [modal]="true"
  [style]="{ width: '26rem' }" [draggable]="false" [appendTo]="'body'">
  <div class="transaction-detail-dialog">
    <label for="receipt-file">Ficheiro do comprovante</label>
    <input id="receipt-file" type="file" class="transaction-detail-dialog__file" (change)="onReceiptSelected($event)"
      accept=".pdf,.png,.jpg,.jpeg" />
    <div class="transaction-detail-dialog__actions">
      <button type="button" class="admin-btn admin-btn--secondary" (click)="receiptDialogVisible = false">
        Cancelar
      </button>
      <button type="button" class="admin-btn admin-btn--success" (click)="submitReceipt()" [disabled]="!receiptFile">
        Enviar
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayNoteModal" [header]="editingNoteId ? 'Editar Observação' : 'Adicionar Nova Observação'"
  [modal]="true" appendTo="body" position="center" [draggable]="false" [resizable]="false" [dismissableMask]="true"
  (onHide)="closeNoteModal()" styleClass="note-modal-dialog">
  <div class="note-modal-content">
    <label for="noteDescription" class="note-label">Descrição (Máx. 500 caracteres)</label>
    <textarea id="noteDescription" class="admin-input note-textarea" [(ngModel)]="newNoteText" rows="4" maxlength="500"
      placeholder="Ex: Usuário contatou o suporte..."></textarea>

    <div class="note-modal-actions">
      <button (click)="closeNoteModal()" class="admin-btn admin-btn--secondary"
        [disabled]="isSavingNote">Cancelar</button>
      <button (click)="saveNote()" class="admin-btn admin-btn--primary"
        [disabled]="!newNoteText.trim() || isSavingNote">
        {{ isSavingNote ? 'Salvando...' : (editingNoteId ? 'Atualizar Observação' : 'Salvar Observação') }}
      </button>
    </div>
  </div>
</p-dialog>
